<template>
   <div>
        <modal
            class="new-modal-small height-top"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="100"
            :width="1000"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
        >
            <div class="pb-2 h-100 bottom-padding ml-2 mr-2">
                <!-- <div class="wizard-bg">
                    <div class="pb-6 px-0 mb-0">
                        <div class="d-flex justify-content-center align-items-center w-100 mt-6">
                            <span :class="basicInfo ? 'selectedCircle' : permissionProduct  ? 'finishedCircle' : 'unfinishedCircle'"
                                class="mx-5">
                                1
                                <span :class="basicInfo ? 'finishedCircleText' : 'unfinishedCircleText'">
                                    Revoke
                                </span>
                            </span>
                            <span class="unfinishedDash"></span>
                            <span
                                :class="permissionProduct ? 'selectedCircle' :  'unfinishedCircle'"
                                class="mx-5">
                                2
                                <span :class="permissionProduct ? 'finishedCircleText' : 'unfinishedCircleText'">
                                    Product Permission
                                </span>
                            </span> 
                        </div>
                    </div>
                </div> -->
                <div v-if="ajax_call_in_progress" class="d-flex align-items-center py-10 justify-content-center">
                    <half-circle-spinner :animation-duration="1000" :size="40" color="#00448b" />
                </div>
                <div v-else class="overflow-auto">
                    <!-- <div v-if="basicInfo" class="mt-12 text-center">
                        <span class="fs-14 text-black fw-500">Are you sure you want to revoke all roles and subscribed product permissions?</span>
                        <div class="mt-10 mb-10">
                            <div class="d-flex align-items-center justify-content-center">
                                <button class="btn btn-outline-secondary" @click="cancel" style="width: 120px;border-radius: 5px;">Cancel</button>
                                <button class="btn btn-new-primary ml-5" style="width: 120px;border-radius: 5px;" @click="switchWizard">Next
                                    <hollow-dots-spinner v-if="save_create_btn_hide" style="position: absolute;width: 160px !important;margin: 0;top: 12px;left: -15px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                </button>
                            </div>
                        </div>
                    </div> -->
                    <div v-if="basicInfo" class="px-4">
                        <div class="row" v-if="loggedInUser.user_role == 'owner' || loggedInUser.user_role == 'super_admin' || loggedInUser.user_role == 'super admin'" >
                            <div class="col-lg-412 col-md-12 col-sm-12 mt-6">
                                <label class="custom-control custom-checkbox digi-checkbox text-center" style="display: inline-block">
                                    <input class="custom-control-input" type="checkbox" v-model="checked" :disabled="check_box_disabled"
                                    name="select_one" />
                                    <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;margin-top:2px"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                                <span class="fs-14 fw-500" style="display: inline-block">Editing user role will remove existing product access which was set earlier!</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-6">
                                <div class="w-100 position-relative">
                                    <span class="input-label">Role<span class="pl-1 text-danger">*</span></span>
                                    <div class="d-flex align-items-center mt-2">
                                        <multiselect class="diginew-multiselect multiselect-height-issue-fix text-capitalize" v-validate="'required'" name="role" :show-labels="false" :searchable="true" :options="role_options" v-model="role" placeholder="Select Role"  @select="getEditNewSubscribedProducts" :disabled="!checked">
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">
                                                    List is Empty
                                                </div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">
                                                    No Results Found
                                                </div>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" v-show="errors.has('role')">
                                        {{errors.first('role')}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="demo-content create-company-container w-100 mt-4" style="max-height:400px;overflow-y:auto !important">
                            <div style="background-color: #00448b;color:#fff;text-align:center;padding:12px;text-transform:uppercase;border-radius: 10px 10px 0px 0px;">Set Product Permissions</div>
                            <table class="table table-new-template table-brand" style="border:1px solid grey">
                                <thead class="text-left">
                                    <tr> 
                                        <th></th>
                                        <th>PRODUCTS</th>
                                        <th class="text-center">PERMISSION</th>
                                        <th >PRODUCT ACCESS</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody >
                                    <tr v-if="!ajax_call_in_progress && products_data.length == 0" class="text-center font-weight-bold">
                                        <td colspan="5" class="text-center">No Producs Found</td>
                                    </tr>
                                    <tr v-if="ajax_call_in_progress_new">
                                        <td colspan="8">
                                            <div class="d-flex align-items-center justify-content-center">
                                                <half-circle-spinner :animation-duration="1000" :size="40" color="#00448b" />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-else v-for="(product, index) in products_data" :key="index" class="sent-call-tr">
                                        <template>
                                            <td></td>
                                            <td>{{product.product_name}}</td>
                                            <td> 
                                                <div class="w-100">
                                                    <div class="ml-auto mr-auto" style="position: relative; justify-content: left;width: 220px;">
                                                        <div v-if="product.has_access" class="d-flex align-items-center" style="margin-top: .7rem !important;">
                                                            <multiselect class="diginew-multiselect product-overflow input-field-underline item" :searchable="true"
                                                                :options="product.permission_options" v-validate="{required:true}" :name="'product_manager'+index" placeholder="Select Permission"
                                                                :disabled="loggedInUser.user_role == 'employee' || (loggedInUser.user_role == 'admin' && (loggedInUser.company_id != $route.params.company_id)) || (comp_data.industry_type == 'Manufacturing' && product.product_name == 'DigiPOS')" 
                                                                label="name" :loading="product.product_roles_loading" :show-labels="false" v-model="product.role_id"
                                                            >
                                                            <template slot="noOptions">
                                                                    <div class="text-secondary text-center fw-600">Manager List is not found</div>
                                                                </template>
                                                                <template slot="noResult">
                                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                                </template>
                                                            </multiselect>
                                                                
                                                        </div>
                                                        <div v-else class="d-flex align-items-center" style="margin-top: .7rem !important;">
                                                            <multiselect class="diginew-multiselect product-overflow input-field-underline item" name="product_manager" :searchable="true"
                                                                :options="product.permission_options" placeholder="Select Permission"
                                                                :disabled="loggedInUser.user_role == 'employee' || (loggedInUser.user_role == 'admin' && (loggedInUser.company_id != $route.params.company_id)) || (comp_data.industry_type == 'Manufacturing' && product.product_name == 'DigiPOS')" 
                                                                label="name" :loading="product.product_roles_loading" :show-labels="false" v-model="product.role_id"
                                                            >
                                                                <template slot="noOptions">
                                                                    <div class="text-secondary text-center fw-600">Manager List is not found</div>
                                                                </template>
                                                                <template slot="noResult">
                                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                                </template>
                                                            </multiselect>
                                                        </div>
                                                        <div v-if="$route.path.startsWith('/stakeholder/editstakeholder/cmpid/')">
                                                            <span class="invalid-feedback-form text-danger" v-if="product.role_id == null && product.has_access">
                                                            Please Select Permission
                                                            </span>
                                                        </div>
                                                        <div v-else>
                                                            <span class="invalid-feedback-form text-danger" v-if="product.role_id.id == '' && product.has_access">
                                                            Please Select Permission
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>  
                                            </td>
                                            <td >
                                                <span class="switch switch-lg mr-2" style="top: 4px;">
                                                    <el-switch 
                                                        :disabled="loggedInUser.user_role == 'employee' || (loggedInUser.user_role == 'admin' && (loggedInUser.company_id != $route.params.company_id)) || (comp_data.industry_type == 'Manufacturing' && product.product_name == 'DigiPOS')"
                                                        active-color="#00448b"
                                                        inactive-color="#bcb8b8"
                                                        v-model ="product.has_access"
                                                        class="routers">
                                                    </el-switch> 
                                                </span>
                                            </td>
                                            <td></td>
                                        </template>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="loggedInUser.user_role == 'owner' || loggedInUser.user_role == 'super admin' || loggedInUser.user_role == 'super_admin'" class="pb-2 pt-4">
                            <div class="d-flex align-items-center justify-content-center">
                                <button class="btn btn-outline-secondary" @click="cancel" style="width: 120px;border-radius: 5px;">Cancel</button>
                                <!-- <button class="btn ml-3 text-white" style="background-color: #ff9a35 !important;width: 120px; border-radius: 5px !important;" @click="backToScreen" >Back</button> -->
                                <button class="btn btn-new-success ml-5" style="width: 120px;border-radius: 5px;" @click="save">Save
                                    <hollow-dots-spinner v-if="save_create_btn_hide" style="position: absolute;width: 160px !important;margin: 0;top: 12px;left: -15px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
         <sweet-modal ref="warning_modal" overlay-theme="dark" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" overlay-theme="dark" icon="success">{{success_msg}}</sweet-modal>
    </div>
</template>

<script>
    import globals from '../globals';
    import { SweetModal } from 'sweet-modal-vue';
    import consultant from '../mixins/consultant';
    import stakeholder from '../mixins/stakeholder';
    import {HalfCircleSpinner} from 'epic-spinners';
    import axios from 'axios';
    import companies from '../mixins/companies';
    export default {
        props: ["modal_name", 'external_id'],
        mixins: [stakeholder, consultant, companies],
        data() {
            return{
                warning_msg: '',
                success_msg: '',
                checked: false,
                role: '',
                role_options: ['consultant', 'advisor', 'investor', 'banker', 'supplier', 'board member', 'share holder'],
                basicInfo:true,
                permissionProduct:false,
                basicInformationTab: false,
                permissionProductTab : false,
                stakeholder_data: {},
                ajax_call_in_progress: false,
                comp_data: {},
                ajax_call_in_progress: false,
                products_data: [],
                old_products_data: [],
                save_create_btn_hide: false,
                validation_permission: false,
                create_success: false,
                check_box_disabled: false,
                ajax_call_in_progress_new: false
            }
        },
        components: {
            HalfCircleSpinner,
            SweetModal
        },
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
        },
        methods: {
            async save() {
                try {
                    this.save_create_btn_hide = true;
                    this.validation_permission = false
                    this.products_data.forEach((x, data_index) => {
                        if(x.has_access == true && x.role_id == null){
                            this.validation_permission = true
                        }
                    })
                    if(this.validation_permission == false){
                        let params = {
                            products: [],
                            role: this.role === 'board member' ? 'board_member' : this.role === 'share holder' ? 'share_holder' : this.role
                        }
                        if(this.stakeholder_data.role.replace(/_/g, ' ') == this.role){
                            this.products_data.forEach((data, index) => {
                                // delete data.product_name
                                if(data.hasOwnProperty('product_roles_loading')) {
                                    delete data.product_roles_loading
                                }
                                if(data.role_id == '' || data.role_id == null || !this.isProductChanged(data)) {
                                    
                                } else {
                                    // if(data.has_access == true){
                                        params.products.push({
                                            id: data.id,
                                            has_access: data.has_access,
                                            product_id: data.product_id,
                                            // role_id: data.role_id.id
                                            role_id: data.role_id.role_id
                                        });
                                    // }
                                }
                            })
                        }else{
                            params.disable = true
                            this.products_data.forEach((data, index) => {
                                // delete data.product_name
                                if(data.hasOwnProperty('product_roles_loading')) {
                                    delete data.product_roles_loading
                                }
                                if(data.role_id == '') {
                                    
                                } else {
                                    if(data.has_access == true){
                                        if(data.id == null){
                                            params.products.push({
                                                has_access: data.has_access,
                                                product_id: data.product_id,
                                                // role_id: data.role_id.id
                                                role_id: data.role_id.role_id
                                            });
                                        }else{
                                            params.products.push({
                                                id: data.id,
                                                has_access: data.has_access,
                                                product_id: data.product_id,
                                                // role_id: data.role_id.id
                                                role_id: data.role_id.role_id
                                            });
                                        }
                                    }
                                }
                            })
                        }
                        if(params.products.length == 0){
                            delete params['products']
                        }
                        await axios.patch(globals.AUTH_SERVICE + `/stakeholder/${this.external_id}`, params).then(response => {
                            if(response.data.status_id == 1) {
                                this.success_msg = response.data.message;
                                this.save_create_btn_hide = false;
                                this.$refs.success_modal.open();
                                setTimeout(() => {
                                    this.$refs.success_modal.close();
                                    this.$emit("hideSucessPopup");
                                }, 2000);
                            }
                        }).catch((err) => {
                            this.save_create_btn_hide = false;
                            this.warning_msg = err.response.data.reason;
                            this.$refs.warning_modal.open();
                        });
                    }
                }
                catch(err) {
                    this.save_create_btn_hide = false;
                    this.warning_msg = err.response.data.reason;
                    this.$refs.warning_modal.open();
                }
            },
            // compare against the products as loaded, so only modified access/permission is sent
            isProductChanged(data) {
                let old_prod = this.old_products_data.find(p => p.product_id === data.product_id)
                if(!old_prod) return true
                let new_role_id = data.role_id ? data.role_id.role_id : ''
                return !!old_prod.has_access !== !!data.has_access || String(old_prod.role_id || '') !== String(new_role_id || '')
            },
            cancel() {
                this.$emit("hidePopup");
            },
            switchWizard(){
                this.permissionProduct = true
                this.basicInfo = false
                this.permissionProductTab = true
                this.basicInformationTab = false
                // this.getEditSubscribedProducts()
            },
            goToListView(){
                this.$router.push('/consultants/listview/cmpid/'+this.$route.params.company_id)
            },
            switchWizard1(){
                this.permissionProduct = false
                this.basicInfo = true
                this.permissionProductTab = false
                this.basicInformationTab = true
            },
            async getEditSubscribedProducts(role){
                this.ajax_call_in_progress = true;
                try {
                    let params = {
                        role: role === 'board member' ? 'board_member' : role === 'share holder' ? 'share_holder' : role,
                        id: this.external_id,
                        company_id: this.$route.params.company_id
                    };
                    let response = await this.getNewProducts(params);
                    if(response.status_id == 1) {
                        let prod_data = response.response;
                        prod_data.forEach((data, index) => {
                            if(data.assigned_role_name != null){
                                this.products_data.push({
                                    id: data.id,
                                    has_access: data.has_access,
                                    // product_id: data.id,
                                    product_id: data.product_id,
                                    product_name: data.product_name,
                                    role_id:
                                    {
                                        role_id: data.assigned_role_id,
                                        name: data.assigned_role_name,
                                    },
                                    permission_options: data.roles,
                                    product_roles_loading: false
                                })
                            }else{
                                this.products_data.push({
                                    id: data.id,
                                    has_access: data.has_access,
                                    // product_id: data.id,
                                    product_id: data.product_id,
                                    product_name: data.product_name,
                                    role_id: '',
                                    permission_options: data.roles,
                                    product_roles_loading: false
                                })
                            }
                        })
                        this.old_products_data = prod_data.map(data => ({
                            product_id: data.product_id,
                            has_access: data.has_access,
                            role_id: data.assigned_role_name != null ? data.assigned_role_id : ''
                        }))
                    }
                    this.ajax_call_in_progress = false;
                }
                catch(err) {
                    console.log(err);
                }
            },
            async getEditNewSubscribedProducts(role){
                this.ajax_call_in_progress_new = true;
                try {
                    let params = {
                        role: role === 'board member' ? 'board_member' : role === 'share holder' ? 'share_holder' : role,
                        id: this.external_id
                    };
                    let response = await this.getNewProducts(params);
                    if(response.status_id == 1) {
                        if(this.stakeholder_data.role == this.role){
                            this.check_box_disabled = false
                        }else{
                            this.check_box_disabled = true         
                        }
                        this.products_data = []
                        let prod_data = response.response;
                        prod_data.forEach((data, index) => {
                            if(data.assigned_role_name != null){
                                this.products_data.push({
                                    id: data.id,
                                    has_access: false,
                                    // product_id: data.id,
                                    product_id: data.product_id,
                                    product_name: data.product_name,
                                    role_id: '',
                                    // {
                                    //     role_id: data.assigned_role_id,
                                    //     name: data.assigned_role_name,
                                    // },
                                    permission_options: data.roles,
                                    product_roles_loading: false
                                })
                            }else{
                                this.products_data.push({
                                    has_access: false,
                                    // product_id: data.id,
                                    product_id: data.product_id,
                                    product_name: data.product_name,
                                    role_id: '',
                                    permission_options: data.roles,
                                    product_roles_loading: false
                                })
                            }
                        })
                    }
                    this.ajax_call_in_progress_new = false;
                }
                catch(err) {
                    console.log(err);
                    this.ajax_call_in_progress_new = false
                }
            },
            async getStakeholderData(){
                this.ajax_call_in_progress = true;
                try {
                    let response = await this.getStakeholderById(this.external_id)
                    this.stakeholder_data = response.response
                    this.role = this.stakeholder_data.role.replace("_", " ");
                    this.getEditSubscribedProducts(response.response.role);
                    this.ajax_call_in_progress = false;
                }
                catch (error) {
                    this.ajax_call_in_progress = false;
                }
            },
            async getCompData() {
                try {
                    let response = await this.getCompanyById(this.$route.params.company_id);
                    if (response.status_id == 1) {
                        let res_data = response.response
                        this.comp_data = res_data
                    }
                }
                catch(err) {
                    // console.log(err)
                }
            },
        },
        mounted(){
            this.getStakeholderData();
        }
    }

</script>

<style scoped>
    .btn-new-success:disabled{
		opacity: 2.1 !important;
    	cursor: not-allowed;
	}
    .btn-outline-secondary {
        color: #e82828;
        border: 1px solid #e82828 !important;
    }
    .btn-outline-secondary:hover {
        color: #fff;
        background-color: #e82828;
        border-color: #e82828 !important;
    }
    .progress-topic{
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 0.47px;
        text-align: left;
        color: #003cb9;
    }
    .wizard-bg{
        background-color: #fff;
        border-radius: 6px;
        /* height: 150px;
         */
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .unfinishedCircle {
        background: #e8e8e8;
        border-radius: 50%;
        height: 50px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(0, 0, 0, 0.32);
        font-weight: 500;
    }

    .finishedCircle {
        background: #128807;
        border-radius: 50%;
        height: 50px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-weight: 500;
    }

    .selectedCircle {
        background: #ff9a06;
        border-radius: 50%;
        height: 50px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-weight: 500;
    }

    .finishedCircleText {
        position: absolute;
        font-size: 14px;
        color: #303031;
        margin-top: 6em;
        font-weight: 600;
    }

    .unfinishedCircleText {
        position: absolute;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.32);
        margin-top: 6em;
        font-weight: 600;
    }

    .unfinishedDash {
        color: #e8e8e8;
        font-size: 20px;
        border-top: 2px dashed rgba(0, 0, 0, 0.32);
        width: 25%
    }

    .finishedDash {
        color: #128807;
        font-size: 20px;
        border: 1px dashed #128807;
        width: 100px;
    }
    /* @media screen and (max-width: 1200px) {
        .wizard-bg{
            height: 160px !important;
            padding-left: 30px;
            padding-right: 33px;
        }
    } */
    @media only screen and (max-width: 768px){
        .bottom-padding{
            padding-bottom: 150px !important;
            margin-right: 5px !important;
        }
    }
    .table-new-template>tbody>tr:nth-of-type(even) td {
        background-color: #dfe8f4;
        padding:10px;
    }
    .table-new-template>tbody>tr:nth-of-type(odd) td {
        background-color: #fff;
        padding:10px;
        
    }
    .table-new-template>tbody>tr:nth-of-type(even) td div >.diginew-multiselect,
    .table-new-template>tbody>tr:nth-of-type(even) td div >.diginew-multiselect> .multiselect__tags{
        background: #dfe8f4!important;
    }
    .table-new-template>tbody>tr:nth-of-type(odd) td div >.diginew-multiselect,
    .table-new-template>tbody>tr:nth-of-type(odd) td div >.diginew-multiselect> .multiselect__tags{
        background: #fff!important;
    }
    .table-new-template thead tr th {
        vertical-align: middle;
        color: #00448b;
        text-transform: capitalize;
        font-weight: 500;
        letter-spacing: 1px;
        white-space: nowrap;
        font-size: 14px;
        text-align: left
    }
    .table-new-template thead th, 
    .table-new-template tbody td{
        align-items: center;
        padding: 10px !important;;

    }
    .table-new-template tbody tr,
    .table-new-template tbody td {
        align-items: center;
        font-weight: 600;
        text-align: left
    }
    .table-new-template>tbody>tr> td div >.diginew-multiselect> .multiselect__tags > .multiselect__placeholder {
        color: #000;
    }
    .table-new-template>tbody>tr:nth-of-type(odd) td div >.diginew-multiselect> .multiselect__tags > .multiselect__input, .multiselect__single{
        background-color:#fff
    }
    .table-new-template>tbody>tr:nth-of-type(even) td div >.diginew-multiselect> .multiselect__tags > .multiselect__input, .multiselect__single{
        background: #dfe8f4!important;
    }
    .overflow-auto::-webkit-scrollbar {
        display: none; 
    }
    .table-new-template>tbody>tr:nth-of-type(even) td div >.diginew-multiselect, .table-new-template>tbody>tr:nth-of-type(even) td div >.diginew-multiselect> .multiselect__tags {
        background: #dfe8f4 !important;
        border-radius: 0px !important;
    }
    .diginew-multiselect .multiselect__tags {
        border: none !important;
        padding: 0 !important;
        padding-right: 40px !important;
        min-height: auto !important;
        background-color: transparent !important;
        height: 31px !important;
        /* overflow: auto !important; */
    }
</style>